import { Button, Dropdown, Menu, Select, Space } from "antd";
import { Option } from "antd/lib/mentions";
import React, { Component } from "react";
import "./app_filters.css";
import { ReactComponent as DropDownIcon } from "../../../ArrowDownIcon.svg";

class AppDropdownFilter3 extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (value) => {
        //console.log(value);
        this.props.onSelectedOptions(value);
    }

    renderCaption = () => {

        return this.props.options && this.props.options.captions.map((item, idx) => {
            return (
                <Option
                    key={item + idx}
                    value={this.props.options.values[idx]}
                    className="dropdown-filter__item"
                >
                    {item}
                </Option>
            );
        });
    }

    render() {
        return (
            <>
                <div>
                    <div className="dropdown-filter3 d-flex justify-content-center align-items-center">
                        <Select
                            style={{
                                width: '100%',
                            }}
                            size={"large"}
                            onChange={this.handleChange}
                            bordered={false}
                            suffixIcon={<DropDownIcon />}
                            defaultValue={this.props.default}
                            value={this.props.value}
                        >
                            {this.renderCaption()}
                        </Select>
                    </div>
                </div>
            </>
        );
    }
}

export default AppDropdownFilter3;
